<template>
    <input type="hidden" :id="identifier" :name="name" :value="fieldValue" @input="updateValue($event.target.value)" v-bind="attributes" />
</template>
<script>
import FormField from "@/mixins/FormField";

export default {
    name: 'HiddenInput',
    mixins: [FormField],
    inheritAttrs: false,
}
</script>
